import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M20 7l-3 5h4l-3 5","key":"svg-0"}],["path",{"d":"M3 16h4a2 2 0 1 1 0 4","key":"svg-1"}],["path",{"d":"M3 12h8a2 2 0 1 0 0 -4","key":"svg-2"}],["path",{"d":"M3 8h3a2 2 0 1 0 0 -4","key":"svg-3"}]]

const IconWindElectricity = createReactComponent('outline', 'wind-electricity', 'WindElectricity', __iconNode);

export default IconWindElectricity;